export {
  applyBootstrap,
  applyDeltas,
  createExecutor,
  drainQuarantine,
  getLastSeq,
  setLastSeq,
  type SyncBootstrapSnapshot,
  type SyncDelta,
} from './shared';

export {
  clearAllQuarantine,
  countQuarantine,
  listQuarantine,
  type QuarantineEntry,
} from './quarantine';

/** Browser: IndexedDB-backed SQLite (wa-sqlite); Node/tests use in-memory sql.js. */
export async function openDatabase(): Promise<import('./types').LocalDatabase> {
  if (typeof window !== 'undefined') {
    try {
      const { openDatabase: openWa } = await import('./wa-sqlite-db.js');
      return await openWa();
    } catch (err) {
      console.error(
        'wa-sqlite failed; falling back to in-memory sql.js (offline edits lost on refresh).',
        err,
      );
      const { setStoragePersistence } = await import('./persistence.js');
      setStoragePersistence('memory');
      const { openDatabase: openSqlJs } = await import('./sqljs-db.js');
      return openSqlJs();
    }
  }
  const { openDatabase: openSqlJs } = await import('./sqljs-db.js');
  return openSqlJs();
}
